export default "__VITE_PUBLIC_ASSET__d674c562__"